export const environment = {
  rememberMeKey: '1_cfqws_3ad_s',
  base_url: 'https://loyaltyapistage.trafalgarluxurygroup.com/api/v1/admin/',
  image_url: 'https://loyaltyapistage.trafalgarluxurygroup.com/api/v1/admin/upload',
  base_url_user: 'https://loyaltyapistage.trafalgarluxurygroup.com/api/v1/user/',
  storageKey: 'C_a_sa1_A_zKo',
  googleKey: 'AIzaSyAIGwIh8vQzHVx7TwIaM8F1K4XR-c30JsI'
};
  